// extracted by mini-css-extract-plugin
export default {"main":"styles_main__nDDs2","mainImg":"styles_mainImg__HjuW1"};